import Loadable from 'UIComponents/decorators/Loadable';
const AsyncExpandableCollaborationSidebar = Loadable({
  loader: () => import(
  /* webpackChunkName: "expandable-collaboration-sidebar" */
  './ExpandableCollaborationSidebar').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncExpandableCollaborationSidebar;